// Core imports
import { Fragment } from 'react';
import { t } from 'i18next';
import { useParams } from 'react-router';

// Component imports
import { Col, Row } from 'antd';
import DocumentTitle from '../components/DocumentTitle';
import Permissioned from '../components/Permissioned';
import KnowledgeBasesTable from '../components/Tables/KnowledgeBasesTable';

// Misc imports
import { PERMISSIONS_GROUP_VIEWER } from '../constants/main';
import useUserPermissions from '../utils/hooks/useUserPermissions';

const OrganizationKnowledgeBasesScreen = () => {
  const { orgId } = useParams();
  const userPermissions = useUserPermissions(orgId, null);
  return (
    <Fragment>
      <DocumentTitle title={t('Knowledge Bases')} />

      <Permissioned
        allowedPermissions={PERMISSIONS_GROUP_VIEWER}
        currentPermissions={userPermissions}
      >
        <Row gutter={24}>
          <Col span={24}>
            <KnowledgeBasesTable />
          </Col>
        </Row>
      </Permissioned>
    </Fragment>
  );
};

export default OrganizationKnowledgeBasesScreen;
